import { getFavoriteArticlesOptions } from "@/api/queryOptions";
import ArticleCardList from "@/components/articles/ArticleCardList";
import { useSuspenseQuery } from "@tanstack/react-query";
// import { Suspense } from "react";

export const MyAcademyArticles = (): JSX.Element => {
	const { data: favoriteArticles } = useSuspenseQuery(
		getFavoriteArticlesOptions
	);

	return (
		
		<>
			{favoriteArticles?.favorites.map((article) => (
				<ArticleCardList key={article.wp_data.ID} article={article.wp_data} />
			))}
		</>
	);
};
